import React from "react";
import {IconButton, Stack, Tooltip, Typography} from "@mui/material";
import {IconMenu2} from "@tabler/icons-react";
import {UI, rgba} from "../../uiTokens";

/**
 * A compact, tooltip-wrapped icon button for panel headers.
 * `danger` swaps the accent hover for the destructive colour.
 */
export const HeaderIconButton = React.forwardRef(function HeaderIconButton(
    {label, danger = false, children, ...props}, ref) {
    const color = danger ? UI.danger : UI.accent;
    return (
        <Tooltip title={label || ""} disableInteractive>
            <span>
                <IconButton
                    ref={ref}
                    size="small"
                    {...props}
                    sx={{
                        color: danger ? UI.danger : UI.muted,
                        "&:hover": {backgroundColor: rgba(color, 0.1), color: danger ? UI.danger : UI.ink},
                        ...props.sx,
                    }}
                >
                    {children}
                </IconButton>
            </span>
        </Tooltip>
    );
});

/**
 * The top bar shared by the node edit panel and the form panel:
 * an optional collapse button, a capitalised title, and whatever action
 * controls the caller passes as children.
 */
export const EditMenuHeader = ({title, onBack, children}) => (
    <Stack direction="row" alignItems="center" gap={0.5} sx={{width: "100%"}}>
        {onBack && (
            <HeaderIconButton label="Hide panel" onClick={onBack}>
                <IconMenu2 size={17}/>
            </HeaderIconButton>
        )}
        <Typography
            noWrap
            sx={{
                flex: 1,
                textTransform: "capitalize",
                fontWeight: 700,
                fontSize: 14,
                color: UI.ink,
                letterSpacing: "0.01em",
            }}
        >
            {title}
        </Typography>
        {children}
    </Stack>
);
